<app-full-page-message
    *ngIf="businessId && businessId.length > 5 && !localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)" />
<div
    *ngIf="!businessId || businessId.length < 5 || localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)">
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.qr_payment">
        <div class="center" style="max-width: 600px;">
            <div class="row" *ngIf="items.length > 0">
                <div class="col-6">
                    <button class="button_icon icon_adjust button_icon_color" (click)="onAction(4)">arrow_back</button>
                    <button class="button_icon icon_adjust button_icon_color" (click)="onLoad()">refresh</button>
                </div>
                <div class="col-6" style="text-align: right;">
                    <button class="button_icon icon_adjust button_icon_color" (click)="onAction(1)">note_add</button>
                </div>
            </div>
            <div class="row" *ngIf="items.length == 0">
                <div class="col-12" style="text-align: center; margin-top: 10%;">
                    <button style="font-size: 45px !important;" class="button_icon icon_adjust button_icon_color"
                        (click)="onAction(1)">note_add</button>
                </div>
            </div>
            <div class="banner custom_rows_body" *ngIf="items.length > 0">
                <div class="row styled_row" *ngFor="let item of items">
                    <div class="col-4">
                        <button class="button_icon icon_adjust"
                            title="{{item.v2 == '1' ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}"
                            (click)="onAction(2,item.key)"
                            [ngStyle]="{'color': item.v2 == '1' ? 'yellowgreen' : 'orangered' }">{{item.v2 == '1' ?
                            "toggle_on" : "toggle_off"}}</button>
                        <button class="button_icon icon_adjust button_icon_color" [disabled]="item.v3 == '1'"
                            title="{{localService.languageContent.qr_payment.is_primary}}"
                            [ngClass]="item.v3 == '1' ? 'material-icons' :'material-icons-outline'"
                            (click)="onAction(3,item.key)">{{item.v3 == '1' ?
                            "check_circle" : "circle"}}</button>
                        <button class="button_icon icon_adjust button_icon_color"
                            (click)="onAction(1,item.key)">edit</button>
                    </div>
                    <div class="col-6">
                        <span>{{item.v1}}</span>
                    </div>
                    <div class="col-2" style="text-align: right;">
                        <button type="button" class="btn btn-primary"
                            (click)="onAction(5,item.key)">{{localService.languageContent.qr_payment.test}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div>
    <app-edit-payment-gateway-config [(isOpenPopup)]="isOpenEditConfigPopup" [businessId]="businessId"
        [countryCode]="ctryCode" [gatewayType]="gatewayType" [id]="selectedIdToEdit" (onClose)="onLoad()" />
    <app-payment-qr-image [businessId]="businessId" [gatewayType]="gatewayType" [configId]="selectedIdToEdit"
        [(isGenerateQr)]="isGenerateQr" [amount]="1" />
</div>